import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const { pathname } = useLocation();

  const links = [
    { to: '/', label: 'Home' },
    { to: '/case-studies', label: 'Case Studies' },
    { to: '/blog', label: 'Blog' },
    { to: '/about', label: 'About' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="flex items-center text-3xl font-bold text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-9 w-9" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="16 18 22 12 16 6" />
              <polyline points="8 6 2 12 8 18" />
            </svg>
            Retic
          </Link>

          <div className="hidden md:flex items-center space-x-8">
            {links.map(l => (
              <Link key={l.to} to={l.to}
                className={`font-medium transition ${pathname === l.to ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'}`}>
                {l.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:block">
            <Link to="/growth-audit" className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-full font-medium transition transform hover:scale-105">
              Free Growth Audit
            </Link>
          </div>

          <button onClick={() => setMobileOpen(!mobileOpen)} className="md:hidden text-gray-700 hover:text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {mobileOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              }
            </svg>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t">
            {links.map(l => (
              <Link key={l.to} to={l.to} onClick={() => setMobileOpen(false)}
                className="block py-3 px-4 text-gray-700 hover:text-blue-600 font-medium">
                {l.label}
              </Link>
            ))}
            <Link to="/growth-audit" onClick={() => setMobileOpen(false)}
              className="block mx-4 mt-2 text-center bg-blue-600 text-white py-3 rounded-full font-medium">
              Free Growth Audit
            </Link>
          </div>
        )}
      </div>
    </nav>
  );
}
